import { render, staticRenderFns } from "./index.vue?vue&type=template&id=783f3474&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('783f3474')) {
      api.createRecord('783f3474', component.options)
    } else {
      api.reload('783f3474', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=783f3474&", function () {
      api.rerender('783f3474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ops/invites/index.vue"
export default component.exports